export const GENDER = {
  MALE: 'مرد',
  FEMALE: 'زن',
};

export const DAYS_OF_WEEK = {
  SAT: 'شنبه',
  SUN: 'یکشنبه',
  MON: 'دوشنبه',
  TUE: 'سه‌شنبه',
  WED: 'چهارشنبه',
  THU: 'پنج‌شنبه',
  FRI: 'جمعه',
};

export const ADVISE_SESSION_TYPE = {
  CHAT: 'متنی',
  VOICE_CALL: 'صوتی',
  VIDEO_CALL: 'تصویری',
  VOIP_CALL: 'تلفنی',
  HOME_CARE: 'ویزیت در منزل',
  FAMILY_DOCTOR: 'خانواده',
};

export const ADVISE_SESSION_STATUS = {
  PENDING: 'منتظر تایید',
  CANCELED: 'لغو شده',
  ACCEPTED: 'رزرو شده',
  REJECTED: 'رد شده',
  CLOSED: 'اتمام',
};

export const INSTANT_ADVISE_SESSION_CATEGORY = {
  MEDICAL: 'پزشک عمومی',
  PSYCHOLOGY: 'روانشناس',
};

export const DOCS = [
  {id: 'NATIONAL_IDENTITY_CARD', name: 'کارت ملی'},
  {id: 'BIRTH_CERTIFICATE', name: 'صفحات شناسنامه'},
  {id: 'BUSINESS_LICENSE', name: 'مجوز یا کارت فعالیت'},
  {id: 'OTHER', name: 'سایر مدارک'},
];

export const NEWS_CATEGORY_PEZESHKET = 1;
export const NEWS_CATEGORY_HEALTH = 2;
export const NEWS_CATEGORY_ARTICLES = 3;
export const NEWS_CATEGORY_NEWS = 4;
export const NEWS_CATEGORY_ANNOUNCEMENT = 5;

export const ADVISE_SESSION_BASE_DURATION = 20; // minutes
export const PSYCOLOGY_SESSION_BASE_DURATION = 10; // minutes

export const FAMILY_DOCTOR_BASE_DURATION = 30 * 24 * 60; // minutes

export const ADVISE_SESSION_DURATIONS = {
  itemList: [
    {
      label: 'پایه',
      value: ADVISE_SESSION_BASE_DURATION,
    },
    {
      label: 'تکمیلی',
      value: ADVISE_SESSION_BASE_DURATION * 2,
    },
    {
      label: 'طولانی',
      value: ADVISE_SESSION_BASE_DURATION * 3,
    },
  ],
  set setList(list) {
    this.itemList = list;
  },
  get getList() {
    return this.itemList;
  },
};

export const PsychologyStatus = {
  psycho: false,
  baseDuration: ADVISE_SESSION_BASE_DURATION,
  get psycoStatus() {
    return this.psycho;
  },
  set setPsyco(p) {
    this.psycho = p;
    if (this.psycho) {
      this.baseDuration =
        ADVISE_SESSION_BASE_DURATION + PSYCOLOGY_SESSION_BASE_DURATION;

      ADVISE_SESSION_DURATIONS.setList = [
        {
          label: 'پایه',
          value: this.baseDuration,
        },
        {
          label: 'تکمیلی',
          value: this.baseDuration * 2,
        },
        {
          label: 'طولانی',
          value: this.baseDuration * 3,
        },
      ];
    } else {
      this.baseDuration = ADVISE_SESSION_BASE_DURATION;
      ADVISE_SESSION_DURATIONS.setList = [
        {
          label: 'پایه',
          value: this.baseDuration,
        },
        {
          label: 'تکمیلی',
          value: this.baseDuration * 2,
        },
        {
          label: 'طولانی',
          value: this.baseDuration * 3,
        },
      ];
    }
  },
};
export const FAMILY_DOCTOR_DURATIONS = [
  {
    label: 'یک ماهه',
    value: FAMILY_DOCTOR_BASE_DURATION,
  },
  {
    label: 'دو ماهه',
    value: FAMILY_DOCTOR_BASE_DURATION * 2,
  },
  {
    label: 'سه ماهه',
    value: FAMILY_DOCTOR_BASE_DURATION * 3,
  },
];

export const ADVISE_SESSION_RECOMMENDATION_PRIORITY = {
  LOW: 'فوریت کم',
  MEDIUM: 'نیمه فوری',
  HIGH: 'فوری',
};

export const LOCATION_STATE = {
  onlineDoctorAdvisers: {
    title: 'پزشکان و مشاوران آنلاین',
    params: {
      online: true,
      category: 'DOCTOR',
      'accepting[]': 'HOME_CARE',
    },
  },
  homeCareDoctorAdvisers: {
    title: 'لیست پزشکان و مشاوران ویزیت در منزل',
    params: {
      category: 'DOCTOR',
      'accepting[]': 'HOME_CARE',
    },
  },
  onlineVetAdvisers: {
    title: 'دامپزشکان آنلاین',
    params: {
      online: true,
      category: 'VET',
    },
  },
  latestVetAdvisers: {
    title: 'دامپزشکان جدید',
    params: {
      category: 'VET',
      sortBy: 'BECOME_ADVISER_TIME',
      sortDirection: 'DESC',
    },
  },
  homeCareVetAdvisers: {
    title: 'لیست دامپزشکان خدمت در محل',
    params: {
      category: 'VET',
      'accepting[]': 'HOME_CARE',
    },
  },
  onlineNurseAdvisers: {
    title: 'پرستاران آنلاین',
    params: {
      online: true,
      category: 'NURSE',
    },
  },
  latestNurseAdvisers: {
    title: 'پرستاران جدید',
    params: {
      category: 'NURSE',
      sortBy: 'BECOME_ADVISER_TIME',
      sortDirection: 'DESC',
    },
  },
  homeCareNurseAdvisers: {
    title: 'لیست پرستاران ویزیت در منزل',
    params: {
      category: 'NURSE',
      'accepting[]': 'HOME_CARE',
    },
  },
  onlineParamedicAdvisers: {
    title: 'پیراپزشکان آنلاین',
    params: {
      online: true,
      category: 'PARAMEDIC',
    },
  },
  latestParamedicAdvisers: {
    title: 'پیراپزشکان جدید',
    params: {
      category: 'PARAMEDIC',
      sortBy: 'BECOME_ADVISER_TIME',
      sortDirection: 'DESC',
    },
  },
  homeCareParamedicAdvisers: {
    title: 'لیست پیراپرشکان ویزیت در منزل',
    params: {
      category: 'PARAMEDIC',
      'accepting[]': 'HOME_CARE',
    },
  },
};

export function getAdviserTimeString(time) {
  const psychoarray = [30, 90];
  const defaultoarray = [20, 40];
  const commonvalue = 60;
  if (defaultoarray.includes(time)) {
    return time === 20 ? 'پایه' : 'تکمیلی';
  }

  if (psychoarray.includes(time)) {
    return time === 30 ? 'پایه' : 'طولانی ';
  }

  if (time === commonvalue) {
    return `${commonvalue} دقیقه ای`;
  }

  return '';
}
